/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';

export default class TSEigenleistungKubikmeterDaten extends TSAbstractEntity implements TSSerializable<TSEigenleistungKubikmeterDaten> {

    private _kubikmeter: number;

    private _betrag: number;

    private _deleted: boolean = false;

    public static getDeserializer = (eigenleistung: any) => {
        return new TSEigenleistungKubikmeterDaten().deserialize(eigenleistung);
    };

    public static getSerializer = (eigenleistung: any) => {
        return eigenleistung.serialize(eigenleistung);
    };

    public get kubikmeter(): number {
        return this._kubikmeter;
    }

    public set kubikmeter(value: number) {
        this._kubikmeter = value;
    }

    public get betrag(): number {
        return this._betrag;
    }

    public set betrag(value: number) {
        this._betrag = value;
    }

    public get deleted(): boolean {
        return this._deleted;
    }

    public set deleted(value: boolean) {
        this._deleted = value;
    }

    deserialize(restObject: any): TSEigenleistungKubikmeterDaten {
        super.deserialize(restObject);

        this.kubikmeter = restObject.kubikmeter;
        this.betrag = restObject.betrag;
        this.deleted = restObject.deleted;

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);

        restObject.kubikmeter = this.kubikmeter;
        restObject.betrag = this.betrag;
        restObject.deleted = this.deleted;

        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSEigenleistungKubikmeterDaten.ts